import { render, staticRenderFns } from "./ShippingSummary.vue?vue&type=template&id=22e41454&"
import script from "./ShippingSummary.vue?vue&type=script&lang=js&"
export * from "./ShippingSummary.vue?vue&type=script&lang=js&"
import style0 from "./ShippingSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports